import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";
import { fetchListingCreditUsage } from "../services/listingPurchases";

const useListingCredits = () => {
    const { user } = useAuth();
    const [credits, setCredits] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const refresh = useCallback(async () => {
        if (!user?.id) {
            setCredits(null);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const usage = await fetchListingCreditUsage(user.id, user.email);
            setCredits(usage);
        } catch (err) {
            console.error("Failed to load listing credits:", err);
            setError(err instanceof Error ? err.message : "Failed to load listing credits");
            setCredits(null);
        } finally {
            setLoading(false);
        }
    }, [user?.id, user?.email]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    // Listen for custom event to refresh credits across all components
    useEffect(() => {
        const handleRefreshCredits = async () => {
            // Force refresh when event is triggered
            if (!user?.id) {
                setCredits(null);
                setLoading(false);
                setError(null);
                return;
            }

            setLoading(true);
            setError(null);

            try {
                const usage = await fetchListingCreditUsage(user.id, user.email);
                setCredits(usage);
            } catch (err) {
                console.error("Failed to load listing credits:", err);
                setError(err instanceof Error ? err.message : "Failed to load listing credits");
                setCredits(null);
            } finally {
                setLoading(false);
            }
        };

        window.addEventListener('refreshCredits', handleRefreshCredits);
        return () => {
            window.removeEventListener('refreshCredits', handleRefreshCredits);
        };
    }, [user?.id, user?.email]);

    return {
        credits,
        loading,
        error,
        refresh,
    };
};

export default useListingCredits;

